import React, { useEffect, useState } from "react";
import "./Cancel_order_details.css";

import { useParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import {
  getCanceledOrder,
  getOrder,
} from "../../../../features/order/orderSlice";
import { decodeId, formatDate } from "../../../../utils/common";
import Cancel_order_details_table from "./Cancel_order_details_table/Cancel_order_details_table";
import Common_Back_Header from "../../../common_components/common_back_header/Common_Back_Header";
import Order_id_holder from "../order_details/order_id_holder/Order_id_holder";
import Receiver_info_holder from "../order_details/receiver_info_holder/Receiver_info_holder";
import Payment_Summary from "../order_details/payment_summary/Payment_Summary";
function Cancel_order_details() {
  const breadcrumbs = [
    { label: "Home", link: "/", isActive: false },
    { label: "MY ORDERS", link: "/account", isActive: false },
    { label: "CANCELLED ORDER DETAILS", link: "", isActive: true },
  ];

  const { id } = useParams();

  const [showCancelBtn, setShowCancelBtn] = useState();

  const dispatch = useDispatch();
  const order = useSelector((state) => state.order.order);
  useEffect(() => {
    const res = dispatch(getCanceledOrder(id));
    if (res.meta?.requestStatus === "fulfilled") {
      setShowCancelBtn(false);
    } else if (res.meta?.requestStatus === "rejected") {
      setShowCancelBtn(true);
    }
  }, [dispatch]);

  return (
    <>
      <section className="Order_details">
        <div className="container">
          <Common_Back_Header 
          // backNavigation="/my-orders" 
          backNavigation="/my-orders?tab=third"
          />

          <div className="row">
            <div className=" col-lg-8 col-md-7">
              <Order_id_holder
                headingText={`Order ID #${order?.Product_Order?.invoice_no}`}
                date={formatDate(order?.updatedAt)}
                time={new Date(order?.updatedAt).toLocaleTimeString("en-IN", {
                      hour: "2-digit",
                      minute: "2-digit",
                      hour12: true,
                    })}
                subText="Cancelled"
                reason={order?.Product_Order?.cancel_reason}
                order={order}
                delivery={true}
              />

              <Cancel_order_details_table order={order} />
            </div>
            <div className="col-lg-4 col-md-5">
              <Receiver_info_holder
                showCancelBtn={showCancelBtn}
                order={order}
                user={order?.Product_Order?.User}
                userAddress={order?.Product_Order?.User_Address}
                billing_user_address={order?.Product_Order?.billing_address}
              />

              <Payment_Summary data={order} refund={true} />
            </div>
          </div>
        </div>
      </section>
    </>
  );
}

export default Cancel_order_details;
